import { Msg } from "@shared/components";

interface FairnessStepProps {
  onOptionalClick: () => void;
  isWebcamRequired: boolean;
}

export const FairnessStep = ({
  onOptionalClick,
  isWebcamRequired,
}: FairnessStepProps) => {
  return (
    <div className="code-editor-exam-detail__fairness">
      <div className="code-editor-exam-detail__fairness__text">
        <Msg id="editor-exam-detail.modals.secondModal.text" />
      </div>
      <div className="code-editor-exam-detail__fairness__warning">
        <Msg id="editor-exam-detail.modals.secondModal.warning" />
      </div>
      <div className="code-editor-exam-detail__fairness__icon-container">
        <div className="code-editor-exam-detail__fairness__icon" />
      </div>
      {!isWebcamRequired && (
        <div className="code-editor-exam-detail__fairness__optional-link-container">
          <span onClick={onOptionalClick}>
            <Msg
              id="editor-exam-detail.modals.secondModal.optionalText"
              className="code-editor-exam-detail__fairness__optional-link-container__optional-link"
            />
          </span>
        </div>
      )}
    </div>
  );
};
